import { render, staticRenderFns } from "./ObjetiveForm.vue?vue&type=template&id=250a5210"
import script from "./ObjetiveForm.vue?vue&type=script&lang=js"
export * from "./ObjetiveForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('250a5210')) {
      api.createRecord('250a5210', component.options)
    } else {
      api.reload('250a5210', component.options)
    }
    module.hot.accept("./ObjetiveForm.vue?vue&type=template&id=250a5210", function () {
      api.rerender('250a5210', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/referral-management/search/components/ObjetiveForm.vue"
export default component.exports